'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en_US = require('../locale/en_US');

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _en_US2['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/lib/locale-provider/en_US.js
// module id = 4MOl
// module chunks = 16